//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
`;
export const Table = styled.table`
    border-collapse: collapse;
    thead {
        background-color: var(--purple-6);
        border: 1px solid var(--purple-6);
    }
    th {
        text-align: start;
        font-weight: 900;
        color: var(--light-1);
        padding: 15px 20px;
    }
    tbody {
        border: 1px solid var(--light-3);
        tr:nth-child(odd) {
            background-color: var(--light-3);
        }
    }
    td {
        padding: 5px 20px;
        font-size: 14px;
        &:nth-child(1) {
            font-weight: 600;
        }
        &:nth-child(2) {
            font-weight: 900;
            color: var(--light-gray-5);
        }
    }
`;